"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClubAnalyticsSaga = void 0;

var inversify_1 = require("inversify");

var effects_1 = require("redux-saga/effects");

var social_core_1 = require("@xbox/social-core");

var AnalyticsActions_1 = require("../actions/AnalyticsActions");

var Utils_1 = require("./Utils");

var ClubAnalyticsSaga =
/** @class */
function () {
  function ClubAnalyticsSaga(analyticsService, telemetryService, notificationService) {
    this.analyticsService = analyticsService;
    this.telemetryService = telemetryService;
    this.notificationService = notificationService;
    this.sagas = [this.watchFetchFeedAnalytics(), this.watchFetchAdminAnalytics(), this.watchFetchCSVAnalytics()];
  }

  ClubAnalyticsSaga.prototype._fetchAdminAnalytics = function (action) {
    var requestStart, result, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 5,, 7]);

          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchAdminAnalyticsInProgress(true))];

        case 1:
          _a.sent();

          this.telemetryService.trackEvent("FetchClubAdminAnalytics", {
            "clubId": action.payload.clubId,
            "action": "admin_analytics"
          });
          requestStart = Date.now();
          return [4
          /*yield*/
          , this.analyticsService.getAdminActionAnalytics(action.payload.clubId, action.payload.month)];

        case 2:
          result = _a.sent();

          if (!result) {
            this.notificationService.notifyWarning("ClubAnalyticsAdminActionsData");
          }

          this.telemetryService.trackLoadTime("ClubAdminAnalyticsFetched", requestStart);
          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchAdminAnalyticsCompleted(result.data))];

        case 3:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchAdminAnalyticsInProgress(false))];

        case 4:
          _a.sent();

          return [3
          /*break*/
          , 7];

        case 5:
          err_1 = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchAdminAnalyticsInProgress(false))];

        case 6:
          _a.sent();

          Utils_1.LogHttpsError("Unable to fetch club admin analytics", err_1);
          this.telemetryService.trackException(err_1, "ClubAdminAnalyticsError", {
            "clubId": action.payload.clubId,
            "action": "admin_analytics"
          });
          return [3
          /*break*/
          , 7];

        case 7:
          return [2
          /*return*/
          ];
      }
    });
  };

  ClubAnalyticsSaga.prototype._fetchFeedAnalytics = function (action) {
    var requestStart, result, err_2;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 5,, 7]);

          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchFeedAnalyticsInProgress(true))];

        case 1:
          _a.sent();

          this.telemetryService.trackEvent("FetchClubFeedAnalytics", {
            "clubId": action.payload.clubId,
            "action": "feed_engagement_analytics"
          });
          requestStart = Date.now();
          return [4
          /*yield*/
          , this.analyticsService.getFeedAnalytics(action.payload.clubId, action.payload.month)];

        case 2:
          result = _a.sent();

          if (!result) {
            this.notificationService.notifyWarning("ClubAnalyticsFeedEngagementData");
          }

          this.telemetryService.trackLoadTime("ClubFeedAnalyticsFetched", requestStart);
          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchFeedAnalyticsCompleted(result.data))];

        case 3:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchFeedAnalyticsInProgress(false))];

        case 4:
          _a.sent();

          return [3
          /*break*/
          , 7];

        case 5:
          err_2 = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchFeedAnalyticsInProgress(false))];

        case 6:
          _a.sent();

          Utils_1.LogHttpsError("Unable to fetch club feed analytics", err_2);
          this.telemetryService.trackException(err_2, "ClubFeedAnalyticsError", {
            "clubId": action.payload.clubId,
            "action": "feed_engagement_analytics"
          });
          return [3
          /*break*/
          , 7];

        case 7:
          return [2
          /*return*/
          ];
      }
    });
  };

  ClubAnalyticsSaga.prototype._fetchCSVAnalytics = function (action) {
    var requestStart, feedResults, adminResults, result, err_3;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 6,, 8]);

          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchCSVAnalyticsInProgress(true))];

        case 1:
          _a.sent();

          this.telemetryService.trackEvent("FetchCSVClubFeedAnalytics", {
            "clubId": action.payload.clubId,
            "action": "csv_feed_engagement_analytics"
          });
          requestStart = Date.now();
          return [4
          /*yield*/
          , this.analyticsService.getFeedAnalytics(action.payload.clubId, action.payload.month, true)];

        case 2:
          feedResults = _a.sent();
          return [4
          /*yield*/
          , this.analyticsService.getAdminActionAnalytics(action.payload.clubId, action.payload.month, true)];

        case 3:
          adminResults = _a.sent();
          result = {
            "feedData": feedResults.data,
            "adminData": adminResults.data
          };
          this.telemetryService.trackLoadTime("CSVClubAnalyticsFetched", requestStart);
          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchCSVAnalyticsCompleted(result))];

        case 4:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchCSVAnalyticsInProgress(false))];

        case 5:
          _a.sent();

          return [3
          /*break*/
          , 8];

        case 6:
          err_3 = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(AnalyticsActions_1.AnalyticsActions.fetchCSVAnalyticsInProgress(false))];

        case 7:
          _a.sent();

          Utils_1.LogHttpsError("Unable to fetch csv club analytics", err_3);
          this.telemetryService.trackException(err_3, "CSVClubAdminAnalyticsError", {
            "clubId": action.payload.clubId,
            "action": "csv_admin_analytics"
          });
          return [3
          /*break*/
          , 8];

        case 8:
          return [2
          /*return*/
          ];
      }
    });
  };

  ClubAnalyticsSaga.prototype.watchFetchFeedAnalytics = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(AnalyticsActions_1.AnalyticsActions.fetchFeedAnalytics.type, this._fetchFeedAnalytics.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  ClubAnalyticsSaga.prototype.watchFetchAdminAnalytics = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(AnalyticsActions_1.AnalyticsActions.fetchAdminAnalytics.type, this._fetchAdminAnalytics.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  ClubAnalyticsSaga.prototype.watchFetchCSVAnalytics = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(AnalyticsActions_1.AnalyticsActions.fetchCSVAnalytics.type, this._fetchCSVAnalytics.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  ClubAnalyticsSaga = __decorate([inversify_1.injectable(), __param(0, inversify_1.inject(social_core_1.XSocialSymbols.IAnalyticsService)), __param(1, inversify_1.inject(social_core_1.XSocialSymbols.ITelemetryService)), __param(2, inversify_1.inject(social_core_1.XSocialSymbols.INotificationsService)), __metadata("design:paramtypes", [Object, Object, Object])], ClubAnalyticsSaga);
  return ClubAnalyticsSaga;
}();

exports.ClubAnalyticsSaga = ClubAnalyticsSaga;